import { render, staticRenderFns } from "./ListaUserBooking.vue?vue&type=template&id=5ae5fab4"
import script from "./ListaUserBooking.vue?vue&type=script&lang=js"
export * from "./ListaUserBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports